import React, { useContext, useEffect, useState } from 'react';
import { Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';

const Container = styled(Pressable)`
  border-width: 2px;
  border-style: solid;
  border-color: red;
  background-color: white;
  padding-horizontal: 20px;
`;

const Alert = styled(Text)`
  font-weight: 600;
`;

import AuthContext from 'app/src/contexts/AuthContext';

const DegradedCheck = () => {
  const { cableMonitor } = useContext(AuthContext);
  const [degraded, setDegraded] = useState(false);

  useEffect(() => {
    if (!cableMonitor) { return; }

    const interval = setInterval(() => {
      if (cableMonitor.connection.disconnected) {
        if (!degraded) { setDegraded(true); }
      } else {
        if (degraded) { setDegraded(false); }
      }
    }, 500);

    return () => clearInterval(interval);
  }, [cableMonitor, degraded, setDegraded]);

  if (!degraded) { return null; }

  return (
    <Container onPress={() => window.location.reload()}>
      <Alert>AUTO UPDATES DEGRADED!</Alert>
      <Text>Trying to reconnect... Click Here to Refresh</Text>
    </Container>
  );
};

export default DegradedCheck;
